import {Grid, Typography} from '@mui/material';
import {get} from 'lodash';
import {
  EtsyBulkCreateCsvItem,
  EtsyBulkCreateGdriveFileItem,
  EtsyBulkCreateGdriveFolderItem,
  EtsyBulkUpdateCsvItem,
  ImageToImageGenerationItem,
} from '../../__generated__/resolvers-types';

export interface JobListItemLogItemProps {
  item:
    | EtsyBulkCreateCsvItem
    | EtsyBulkCreateGdriveFileItem
    | EtsyBulkCreateGdriveFolderItem
    | EtsyBulkUpdateCsvItem
    | ImageToImageGenerationItem;
}

export default function JobListItemLogItem({item}: JobListItemLogItemProps) {
  return (
    <Grid
      container
      spacing={2}
      sx={{border: '1px solid #e0e0e0', borderRadius: 1, p: 2, width: '100%'}}
      justifyContent="space-between"
    >
      <Grid>
        <Typography variant="body2">{get(item, 'name', item.id)}</Typography>
      </Grid>
      <Grid>
        <Typography variant="body2">{item.error}</Typography>
      </Grid>
    </Grid>
  );
}
